import { Directive, HostListener, ElementRef, OnInit } from '@angular/core';

@Directive({
    selector: '[characterFormatter]',
    standalone: false
})
export class CharacterFormatterDirective implements OnInit {
  private el: HTMLInputElement;

  constructor(private elementRef: ElementRef) {
    this.el = this.elementRef.nativeElement;
  }

  ngOnInit() {}

  @HostListener('focus', ['$event.target.value'])
  onFocus(value) {
    this.transform();
  }

  @HostListener('blur', ['$event.target.value'])
  onBlur(value) {
    this.transform();
  }

  @HostListener('input', ['$event.target.value'])
  onInput(value) {
    this.transform();
  }

  transform() {
    if (this.el && this.el.value) this.el.value = this.el.value.replace(/-/g, '_');
  }
}
